export type FontVariant = {
  fontStyle: string;
  fontWeight: string;
  fontDisplay: FontDisplay;
  sources: { src: string; unicodeRange: string }[];
};

export class Font {
  name: string;
  fontFamily: string;
  variants: FontVariant[];
  fontWeights: { [key: string]: string } = {};

  constructor(name: string, fontFamily: string, variants: FontVariant[]) {
    this.name = name;
    this.fontFamily = fontFamily;
    this.variants = variants;
    this.fontWeights = variants.reduce<{ [key: string]: string }>(
      (acc, variant) => {
        acc[variant.fontWeight] = variant.fontWeight;

        return acc;
      },
      {},
    );
  }
}
